import cookie from 'cookie';

function getCsrfToken() {
  const cookies = cookie.parse(document.cookie);
  if ('csrftoken' in cookies) {
    return cookies['csrftoken'];
  }

  return undefined;
}

export default getCsrfToken;
